import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
const PendingIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(SvgIcon, { ...props, ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "29", height: "29", viewBox: "0 0 29 29", children: /* @__PURE__ */ jsxs("g", { "data-name": "Group 17213", children: [
    /* @__PURE__ */ jsx("g", { "data-name": "Group 17205", children: /* @__PURE__ */ jsx(
      "path",
      {
        "data-name": "Path 18368",
        d: "M14.5 0A14.5 14.5 0 1 1 0 14.5 14.5 14.5 0 0 1 14.5 0z",
        fill: "currentColor"
      }
    ) }),
    /* @__PURE__ */ jsx("g", { "data-name": "Group 17207", children: /* @__PURE__ */ jsx("g", { "data-name": "Group 17206", transform: "translate(5.314 12.381)", children: /* @__PURE__ */ jsx("circle", { "data-name": "Ellipse 726", cx: "2.118", cy: "2.118", r: "2.118", fill: "#fff" }) }) }),
    /* @__PURE__ */ jsx("g", { "data-name": "Group 17209", children: /* @__PURE__ */ jsx("g", { "data-name": "Group 17208", transform: "translate(12.381 12.381)", children: /* @__PURE__ */ jsx("circle", { "data-name": "Ellipse 727", cx: "2.118", cy: "2.118", r: "2.118", fill: "#fff" }) }) }),
    /* @__PURE__ */ jsx("g", { "data-name": "Group 17211", children: /* @__PURE__ */ jsx("g", { "data-name": "Group 17210", transform: "translate(19.448 12.381)", children: /* @__PURE__ */ jsx("circle", { "data-name": "Ellipse 728", cx: "2.118", cy: "2.118", r: "2.118", fill: "#fff" }) }) })
  ] }) }) });
});
export {
  PendingIcon
};
//# sourceMappingURL=PendingIcon.js.map
